import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Youtube, Globe } from 'lucide-react';
import ConsultiumLogo from './ConsultiumLogo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <ConsultiumLogo size="default" variant="white" />
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted partner for company registrations, tax services, and business solutions in South Africa.
            </p>
            <div className="flex space-x-4">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 transition-colors">
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-emerald-600" />
                <a href="tel:0128243708" className="hover:text-emerald-600 transition-colors">
                  012 824 3708 <span className="text-xs text-gray-500">(Call Centre)</span>
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-emerald-600" />
                <a
                  href="https://wa.me/27790424911?text=Hi%20Consultium%20Group%2C%20I'd%20like%20to%20chat%20about%20your%20services."
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="hover:text-emerald-600 transition-colors"
                  data-testid="footer-whatsapp-link"
                >
                  079 042 4911 <span className="text-xs text-gray-500">(WhatsApp)</span>
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-emerald-600" />
                <a href="mailto:hello@consultiumgroup.co.za" className="hover:text-emerald-600 transition-colors">
                  hello@consultiumgroup.co.za
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Globe className="h-5 w-5 text-emerald-600" />
                <a
                  href="https://www.consultiumgroup.co.za"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-emerald-600 transition-colors"
                >
                  www.consultiumgroup.co.za
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-400 hover:text-emerald-600 transition-colors">
                Services Info
              </Link>
              <Link to="/faqs" className="block text-gray-400 hover:text-emerald-600 transition-colors" data-testid="footer-faqs-link">
                FAQs
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; Consultium Group 2000-2026. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
